import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { AppDispatch, RootState } from 'redux/store'
import { groupsAPI } from 'redux/api/groupsApi'
import { useGET_groupsQuery } from 'redux/api/groupsApi'
import { clearAllFilters, setSearch } from 'redux/ui/groupsUI'

import PageHeading from 'components/atoms/PageHeading'
import MainTableFiltersForm from 'components/organisms/forms/tableFilters/MainTableFiltersForm'
import MainTable from 'components/organisms/tables/MainTable'
import ExtraFiltersGroups from 'components/organisms/forms/tableFilters/groups/ExtraFilters'

import formModel, { initialValues } from 'utils/tableFilterModels/groupsTableFilterModel'
import { useTableModel } from 'utils/tableModels/useGroupsTableModel'
import { useEffect } from 'react'
import AddStudent from 'components/utilized/dashboard/AddStudent'
import { Group } from '@mui/icons-material'
import BoxTitle from 'components/atoms/BoxTitle'



const GroupsPage = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const reduxKey = 'groups'

  // For Extra filters
  const activeFilters = useSelector((state: RootState) => state[reduxKey].activeFilters)
  const filters = {
    search: useSelector((state: RootState) => state[reduxKey].tableFilters.search),
    grade_level: useSelector((state: RootState) => state[reduxKey].tableFilters.grade_level),
    academic_year: useSelector((state: RootState) => state[reduxKey].tableFilters.academic_year),
    mentor: useSelector((state: RootState) => state[reduxKey].tableFilters.mentor),
  }

  const user = useSelector((state: RootState) => state['user'].user)

  useEffect(() => { 
    dispatch(clearAllFilters())
  }, [])
  
  return (
    <>
      <div style={{ padding: '20px', paddingBottom: '0px' }}><BoxTitle title={t('common.groups')} icon={<Group/>} /></div>

      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_groupsQuery}
        filters={filters}
        header={
          <MainTableFiltersForm
            reduxKey={reduxKey}
            tag="groups"
            entityName={t('common.groups')}
            addLabel={t('common.add-group')}
            api={groupsAPI}
            setSearch={setSearch}
            clearAllFilters={clearAllFilters}
            formModel={formModel}
            initialValues={initialValues}
            activeFilters={activeFilters}
            hideDefaultActions={['teacher'].includes(user?.role)}
            featuredExtraActions={['teacher'].includes(user?.role) && 
                <AddStudent />
            }
          >
            <ExtraFiltersGroups />
          </MainTableFiltersForm>
        }
      />

    </>
  )
}
export default GroupsPage
